import React, { useEffect, useState } from 'react';
import firebase from "../../firebaseConfig";
import "../../styles/generalTabs.css";
import {TiDelete, TiPlus} from "react-icons/ti";
import {FiSave} from "react-icons/fi";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import "primereact/resources/themes/lara-light-indigo/theme.css";
import toast from 'react-simple-toasts';

const FlowRoutines = ({ user }) => {
    const [flowRoutinesData, setFlowRoutinesData] = useState([]);
    const [originalFlowRoutinesData, setOriginalFlowRoutinesData] = useState([]);
    const [isModified, setIsModified] = useState(false);
    const [modalActive, setModalActive] = useState(false);
    const [editRoutine, setEditRoutine] = useState(null);
    const [selectedType, setSelectedType] = useState('');
    
    const routineTypes = [
        "DOMINO EFFECT",
        "EXECUTION",
        "CREATIVITY",
        "TEAM WORK",
        "STUDYING / SKILL ACQUISITION",
        "STAGE PERFORMANCE / COMPETITION",
        "PHYSICAL TRAINING",
        "SOCIAL",
        "COMMUNICATION / SPEECH",
        "BORING / NASTY"
    ];

    useEffect(() => {
        const fetchInputValue = async () => {
            try {
                if (user) {
                    const userId = user.uid;
                    const docRef = firebase.firestore().collection('users').doc(userId);
                    const docSnapshot = await docRef.get();
                    if (docSnapshot.exists) {
                        const data = docSnapshot.data().FlowRoutines_4 || [];
                        setFlowRoutinesData(data);
                        setOriginalFlowRoutinesData(JSON.parse(JSON.stringify(data)));
                    }
                }
            } catch (error) {
                console.log(error);
            }
        };
        fetchInputValue();
    }, [user]);

    useEffect(() => {
        const hasChanged = JSON.stringify(flowRoutinesData) !== JSON.stringify(originalFlowRoutinesData);
        setIsModified(hasChanged);
    }, [flowRoutinesData, originalFlowRoutinesData]);

    const updateFlowRoutinesData = (index, field, value) => {
        setFlowRoutinesData((prevData) => {
            const updatedData = [...prevData];
            updatedData[index][field] = value;
            return updatedData;
        });
    };

    const saveFlowRoutinesData = async () => {
        try {
            if (user) {
                const userId = user.uid;
                const docRef = firebase.firestore().collection('users').doc(userId);
                await docRef.update({ FlowRoutines_4: flowRoutinesData });
                setOriginalFlowRoutinesData(JSON.parse(JSON.stringify(flowRoutinesData)));
                setIsModified(false);
                toast('Saved');
            }
        } catch (error) {
            console.log("Error saving data:", error);
            toast('Error saving data');
        }
    };

    const createNewRoutine = async (type) => {
        try {
            const userId = user.uid;
            const docRef = firebase.firestore().collection('users').doc(userId);
            const newRoutine = {
                type: type,
                singleTask: '',
                struggle: '',
                challengeLevel: '',
                skillLevel: '',
                preFlowPrimer: '',
                impactfulTriggers: '',
                amplifiers: '',
                shortRelease: '',
                shortReentryCue: '',
                longRelease: '',
                longReentryCue: '',
                recovery: ''
            };

            await docRef.update({
                FlowRoutines_4: firebase.firestore.FieldValue.arrayUnion(newRoutine)
            });
            setFlowRoutinesData(prevData => [...prevData, newRoutine]);
            closeModal();
        } catch (error) {
            console.log("Error creating new routine:", error);
        }
    };

    const handleCreateRoutine = () => {
        if (!selectedType) {
            toast('Please select a routine type');
            return;
        }
        createNewRoutine(selectedType);
    };

    const handleSaveRoutine = async () => {
        if (!editRoutine) return;
        const index = flowRoutinesData.findIndex(r => r === editRoutine);
        if (index !== -1) {
            await saveFlowRoutinesData();
        }
        closeModal();
    };

    const closeModal = () => {
        setModalActive(false);
        setEditRoutine(null);
        setSelectedType('');
    };

    const handleDelete = async (index) => {
        const updatedData = [...flowRoutinesData];
        updatedData.splice(index, 1);
        setFlowRoutinesData(updatedData);

        try {
            if (user) {
                const userId = user.uid;
                const docRef = firebase.firestore().collection('users').doc(userId);
                await docRef.update({ FlowRoutines_4: updatedData });
            }
        } catch (error) {
            console.log("Error deleting routine:", error);
        }
    };

    const DisplayModal = () => {
        if (!modalActive && !editRoutine) return null;

        return (
            <div className="modal fade show modal-overlay" style={{ display: "block" }}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            {editRoutine ? 'Edit Flow Routine' : 'Create Flow Routine'}
                            <button
                                className="btn-close"
                                style={{ cursor: "pointer" }}
                                type="button"
                                aria-label="Close"
                                onClick={closeModal}
                            ></button>
                        </div>
                        <div className="modal-body">
                            <div className="form-group">
                                <div className={"d-flex flex-column"}>
                                    {!editRoutine && (
                                        <>
                                            <label htmlFor="typeId">Routine Type</label>
                                            <select
                                                id="typeId"
                                                className="form-select mt-2"
                                                value={selectedType}
                                                onChange={(e) => setSelectedType(e.target.value)}
                                            >
                                                <option value="">-- Select a routine type --</option>
                                                {routineTypes.map((type, idx) => (
                                                    <option key={idx} value={type}>{type}</option>
                                                ))}
                                            </select>
                                        </>
                                    )}

                                    {editRoutine ? (
                                        <button className="btn btn-primary mt-3" onClick={handleSaveRoutine}>Save</button>
                                    ) : (
                                        <button className="btn btn-primary mt-3" onClick={handleCreateRoutine}>Create</button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className="tab-pane containerDashboardContent container-fluid" role="tabpanel" id="tab-4">
            <h5 className={"mt-3"}>
                <span className="introText">
                    "We are what we repeatedly do." - Aristotle
                </span>
            </h5>
            <div className="container">
                <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
                    {flowRoutinesData.map((item, index) => (
                        <div key={index} className="col p-2">
                            <div className="card h-100">
                                <div className="card-header text-center" style={{ backgroundColor: '#f8f9fa', cursor: "pointer" }} onClick={() => setEditRoutine(item)}>
                                    <h5 className="mb-0">{item.type}</h5>
                                </div>
                                <div className="card-body" style={{ position: 'relative', padding: '1rem' }}>
                                    <TiDelete className="text-danger" style={{ fontSize: "1.3em", cursor: "pointer", position: "absolute", top: "8px", right: "8px" }} onClick={() => handleDelete(index)} />
                                    
                                    <FlowRoutineItem title="Single-task/activity:" content={item.singleTask} field="singleTask" index={index} updateFlowRoutinesData={updateFlowRoutinesData} isSection={true} />
                                    
                                    <hr style={{ margin: '0.5rem 0', opacity: 0.2 }} />
                                    
                                    <FlowRoutineItem title="Struggle/Challenge:" content={item.struggle} field="struggle" index={index} updateFlowRoutinesData={updateFlowRoutinesData} isSection={true} />
                                    
                                    <hr style={{ margin: '0.5rem 0', opacity: 0.2 }} />
                                    
                                    <div className="mb-2" style={{ backgroundColor: '#f8f9fa', padding: '0.75rem', borderRadius: '6px', border: '1px solid #e9ecef' }}>
                                        <h6 className="fw-bold mb-2" style={{ color: '#495057', fontSize: '0.9rem' }}>Challenge-skill balance perception (1 to 10 scale):</h6>
                                        <div style={{ paddingLeft: '0.5rem' }}>
                                            <FlowRoutineItem title="Challenge:" content={item.challengeLevel} field="challengeLevel" index={index} updateFlowRoutinesData={updateFlowRoutinesData} isSubItem={true} />
                                            <FlowRoutineItem title="Skill:" content={item.skillLevel} field="skillLevel" index={index} updateFlowRoutinesData={updateFlowRoutinesData} isSubItem={true} />
                                        </div>
                                    </div>
                                    
                                    <FlowRoutineItem title="Pre-flow primer (2-5 simple steps):" content={item.preFlowPrimer} field="preFlowPrimer" index={index} updateFlowRoutinesData={updateFlowRoutinesData} isSection={true} />
                                    
                                    <hr style={{ margin: '0.5rem 0', opacity: 0.2 }} />
                                    
                                    <div className="mb-2" style={{ backgroundColor: '#f8f9fa', padding: '0.75rem', borderRadius: '6px', border: '1px solid #e9ecef' }}>
                                        <h6 className="fw-bold mb-2" style={{ color: '#495057', fontSize: '0.9rem' }}>Entry & stabilization</h6>
                                        <div style={{ paddingLeft: '0.5rem' }}>
                                            <FlowRoutineItem title="Most impactful triggers (1-3):" content={item.impactfulTriggers} field="impactfulTriggers" index={index} updateFlowRoutinesData={updateFlowRoutinesData} isSubItem={true} />
                                            <FlowRoutineItem title="Amplifiers (0-2):" content={item.amplifiers} field="amplifiers" index={index} updateFlowRoutinesData={updateFlowRoutinesData} isSubItem={true} />
                                        </div>
                                    </div>
                                    
                                    <div className="mb-2" style={{ backgroundColor: '#f8f9fa', padding: '0.75rem', borderRadius: '6px', border: '1px solid #e9ecef' }}>
                                        <h6 className="fw-bold mb-2" style={{ color: '#495057', fontSize: '0.9rem' }}>Release (low-demand activity)</h6>
                                        <div style={{ paddingLeft: '0.5rem' }}>
                                            <FlowRoutineItem title="Short (1-5 min):" content={item.shortRelease} field="shortRelease" index={index} updateFlowRoutinesData={updateFlowRoutinesData} isSubItem={true} />
                                            <div style={{ paddingLeft: '0.75rem', marginTop: '0.25rem', paddingTop: '0.25rem', borderLeft: '2px solid #dee2e6' }}>
                                                <FlowRoutineItem title="Re-entry cue:" content={item.shortReentryCue} field="shortReentryCue" index={index} updateFlowRoutinesData={updateFlowRoutinesData} isSubSubItem={true} />
                                            </div>
                                            <FlowRoutineItem title="Long release (10-20 min):" content={item.longRelease} field="longRelease" index={index} updateFlowRoutinesData={updateFlowRoutinesData} isSubItem={true} />
                                            <div style={{ paddingLeft: '0.75rem', marginTop: '0.25rem', paddingTop: '0.25rem', borderLeft: '2px solid #dee2e6' }}>
                                                <FlowRoutineItem title="Re-entry cue:" content={item.longReentryCue} field="longReentryCue" index={index} updateFlowRoutinesData={updateFlowRoutinesData} isSubSubItem={true} />
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <hr style={{ margin: '0.5rem 0', opacity: 0.2 }} />
                                    
                                    <FlowRoutineItem title="Recovery (low-demand/full disconnection):" content={item.recovery} field="recovery" index={index} updateFlowRoutinesData={updateFlowRoutinesData} isSection={true} />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="w-100 d-flex justify-content-center align-items-center gap-3 mt-3">
                    <button 
                        className={`btn ${isModified ? 'btn-primary' : 'btn-secondary'}`}
                        onClick={saveFlowRoutinesData}
                        disabled={!isModified}
                        style={{ opacity: isModified ? 1 : 0.5 }}
                    >
                        <FiSave style={{ marginRight: '0.5rem' }} />
                        Save
                    </button>
                    <TiPlus style={{ fontSize: "1.8em", cursor: "pointer" }} className={"text-primary"} onClick={() => setModalActive(true)} />
                </div>
                <DisplayModal />
            </div>
        </div>
    );
};

export default FlowRoutines;

const FlowRoutineItem = ({ title, content, field, index, updateFlowRoutinesData, isSection, isSubItem, isSubSubItem }) => {
    const [localContent, setLocalContent] = useState(content || '');

    useEffect(() => {
        setLocalContent(content || '');
    }, [content]);

    const handleChange = (value) => {
        setLocalContent(value);
    };

    const handleBlur = () => {
        if (localContent !== content) {
            updateFlowRoutinesData(index, field, localContent);
        }
    };

    const labelClass = isSection ? 'fw-bold' : isSubItem ? 'fw-semibold small' : isSubSubItem ? 'small text-muted' : 'fw-bold small text-muted';
    const marginBottom = isSection ? 'mb-2' : isSubItem ? 'mb-1' : isSubSubItem ? 'mb-1' : 'mb-2';

    return (
        <div className={marginBottom}>
            <label className={labelClass} style={{ fontSize: isSubItem ? '0.85rem' : isSubSubItem ? '0.8rem' : '0.9rem', marginBottom: '0.25rem' }}>{title}</label>
            <ReactQuill
                value={localContent}
                onChange={handleChange}
                onBlur={handleBlur}
                modules={{ 
                    toolbar: [],
                    clipboard: { matchVisual: false }
                }}
                style={{ minHeight: isSubSubItem ? '40px' : isSubItem ? '45px' : '50px' }}
            />
        </div>
    );
};
